import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'
import {
  capturePageView,
  initializeSessionRecording,
} from 'utils/global/posthog'

type RouteChangeTrackerProps = {
  children?: React.ReactNode
}

/**
 * Component that tracks route changes and ensures proper session recording
 */
export const RouteChangeTracker: React.FC<RouteChangeTrackerProps> = ({
  children,
}) => {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    // Get page name from path
    const pageName =
      location.pathname.split('/').filter(Boolean).pop() || 'home'

    // Track route change
    if (posthog) {
      initializeSessionRecording(posthog)

      // Capture page view
      capturePageView(posthog, pageName, {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        referrer: document.referrer,
        url: window.location.href,
      })
    }
  }, [location, posthog])

  // This component doesn't render anything, it just tracks
  return <>{children}</>
}

export default RouteChangeTracker
